import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@sb/ui';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public constructor(
    private readonly router: Router,
    private readonly toast: ToastService,
    private readonly translate: TranslateService,
  ) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestPath = request.url;
    return next.handle(request).pipe(
      tap({
        error: (error) => {
          const ignoreMetaMessage = request?.headers.get('ignore-meta-message') === 'true';

          if (ignoreMetaMessage) {
            return;
          }

          if (error instanceof HttpErrorResponse) {
            this.checkError(error, requestPath);
            return;
          }

          this.serverError(error, requestPath);
        },
      }),
    );
  }

  private checkError(err: HttpErrorResponse, requestPath: string): void {
    if (err.error && err.error.meta) {
      const { meta } = err.error;
      if (meta.status === 'error' && meta.status_message) {
        this.toast.openDanger(meta.status_message);
        return;
      }
    }

    this.serverError(err, requestPath);
  }

  private serverError(err: HttpErrorResponse, requestPath: string): void {
    if (err.status === 403) {
      this.toast.openDanger(this.translate.instant('You do not have permission for this request'));
      return;
    }

    if (err.status === 429) {
      this.toast.openDanger(this.translate.instant('Too many requests'));
      return;
    }

    if ((err.status === 401 || err.status === 409) && requestPath === '/api/auth/login') {
      return;
    }

    // if not logged in / invalid api token
    if (err.status === 401) {
      this.router.navigateByUrl('/logout');
      return;
    }

    this.toast.openDanger(this.translate.instant('An error has occurred'));
    return;
  }
}
